/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Tabinvitations2Inputs */

const zh_organizationsettings_tabinvitations2 = /** @type {(inputs: Organizationsettings_Tabinvitations2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待处理邀请`)
};

const en_organizationsettings_tabinvitations2 = /** @type {(inputs: Organizationsettings_Tabinvitations2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending Invitations`)
};

const es_organizationsettings_tabinvitations2 = /** @type {(inputs: Organizationsettings_Tabinvitations2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitaciones pendientes`)
};

/**
* | output |
* | --- |
* | "Pending Invitations" |
*
* @param {Organizationsettings_Tabinvitations2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_tabinvitations2 = /** @type {((inputs?: Organizationsettings_Tabinvitations2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Tabinvitations2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_tabinvitations2(inputs)
	if (locale === "en") return en_organizationsettings_tabinvitations2(inputs)
	return es_organizationsettings_tabinvitations2(inputs)
});
export { organizationsettings_tabinvitations2 as "organizationSettings_tabInvitations" }